import {Group} from 'src/design/atoms/Group';
import React from 'react';
import {DatePicker} from 'src/design/atoms/DatePicker';

export interface DateRangeFilterProps {
  startDate: Date | null;
  endDate: Date | null;
  onStartDateChange: (date: Date | null) => void;
  onEndDateChange: (date: Date | null) => void;
}

export const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}) => {
  const handleStartDateChange = (date: Date): void => {
    onStartDateChange(date || null);
  };

  const handleEndDateChange = (date: Date): void => {
    onEndDateChange(date || null);
  };

  return (
    <Group grow>
      <DatePicker
        label="Start Date"
        value={startDate}
        maxDate={endDate || undefined}
        onDateChangeCallback={handleStartDateChange}
      />
      <DatePicker
        label="End Date"
        value={endDate}
        minDate={startDate || undefined}
        onDateChangeCallback={handleEndDateChange}
      />
    </Group>
  );
};
